import React, { useState } from "react";
import styles from './JobPost.module.css'

const JobPost = () => {
    const [step, setStep] = useState(1);

  // Function to go to the next step
  const nextStep = () => {
    setStep((prev) => (prev < 5 ? prev + 1 : prev));
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
  };
  return (
    <div className="container-fluid mt-3">
        <div className="my-3 p-2 row">
            <div className="col-md-12">
                <div className="card border-0 shadow-ctm bg-light rounded-3">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                            <div className={`${styles['post-box']} mb-4 mt-3`}>
        <h2 className={`${styles['post-title']}`}>Post A New Job</h2>
        <p className="mb-0"><span className={`${styles['span-title']}`}>for</span> <span className={`${styles['sub-title']}`}>MindClick Technologies</span></p>
              </div>
                <div className={`${styles['inner-post']}`}>
                  {/* Step Navigation */}
              <ul className="nav nav-pills nav-justified navjob-pills mb-4">
                <li className="nav-item">
                  <a className={`nav-link ${step === 1 ? "active" : ""}`} href="#"><span className='nav-span'>1</span><span className={`${styles['bgwhite-ctm']} px-2`}>Job Details</span></a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${step === 2 ? "active" : ""}`} href="#"><span className='nav-span'>2</span><span className={`${styles['bgwhite-ctm']} px-2`}>Candidate Recruitment</span></a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${step === 3 ? "active" : ""}`} href="#"><span className='nav-span'>3</span><span className={`${styles['bgwhite-ctm']} px-2`}>Job Details</span></a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${step === 4 ? "active" : ""}`} href="#"><span className='nav-span'>4</span><span className={`${styles['bgwhite-ctm']} px-2`}>Preview</span></a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${step === 5 ? "active" : ""}`} href="#"><span className='nav-span'>5</span><span className={`${styles['bgwhite-ctm']} px-2`}>Submit</span></a>
                </li>
              </ul>

              <div className={`${styles['box-inner']}`}>
                {/* Form Steps */}
              <div className="card shadow-ctm border-0 rounded-3">
                <div className="card-body">
                  {step === 1 && (
                    <div>
                      <div className="card border-0 shadow-sm rounded-3 mb-3">
                        <div className={`${styles['bgblue-ctm']} text-white`}>
                          <h5>Candidate Requirements</h5>
                          <p className="mb-0">We'll use this requirement details to make your job visible to the right candidates.</p>
                        </div>
                        <div className="card-body">
                          {/* Minimum Qualifications */}
                          <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                  <label className="form-label">Minimum Qualifications <span className="text-danger">*</span></label>
                                  <div className="d-flex flex-wrap gap-2">
                                    <input type="text" className="form-control" placeholder="Select qualification type"/>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label">Key Skills <span className="text-danger">*</span></label>
                                  <div className="d-flex flex-wrap gap-2">
                                    <input type="text" className="form-control" placeholder="Add new key skills"/>
                                  </div>
                                </div>
                            </div>
                          </div>

                          {/* Total Work Experience */}
                          <div className="mb-3">
                            <label className="form-label">Total Work Experience <span className="text-danger">*</span></label>
                            <div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="experience" id="freshers" value="freshers"/>
                                <label className="form-check-label" htmlFor="freshers">Freshers Only</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="experience" id="experienced" value="experienced"/>
                                <label className="form-check-label" htmlFor="experienced">Experienced Only</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input"type="radio"name="experience"id="both"value="both"/>
                                <label className="form-check-label" htmlFor="both">Fresher & Experienced Both</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card border-0 shadow-sm rounded03">
                        <div className={`${styles['bgblue-ctm']} text-white`}>
                          <h5>Candidate Requirements</h5>
                          <p className="mb-0">We'll use this requirement details to make your job visible to the right candidates.</p>
                        </div>
                        <div className="card-body">
                          {/* Minimum Qualifications */}
                          <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                  <label className="form-label">Minimum Qualifications <span className="text-danger">*</span></label>
                                  <div className="d-flex flex-wrap gap-2">
                                    <input type="text" className="form-control" placeholder="Select qualification type"/>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label">Key Skills <span className="text-danger">*</span></label>
                                  <div className="d-flex flex-wrap gap-2">
                                    <input type="text" className="form-control" placeholder="Add new key skills"/>
                                  </div>
                                </div>
                            </div>
                          </div>

                          {/* Total Work Experience */}
                          <div className="mb-3">
                            <label className="form-label">Total Work Experience <span className="text-danger">*</span></label>
                            <div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="experience" id="freshers" value="freshers"/>
                                <label className="form-check-label" htmlFor="freshers">Freshers Only</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="experience" id="experienced" value="experienced"/>
                                <label className="form-check-label" htmlFor="experienced">Experienced Only</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input className="form-check-input"type="radio"name="experience"id="both"value="both"/>
                                <label className="form-check-label" htmlFor="both">Fresher & Experienced Both</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {step === 2 && (
                    <div>
                      <h4>Candidate Recruitment</h4>
                      <p>Provide recruitment details for the position.</p>
                      <div className="mb-3">
                        <label className="form-label">Functional Area *</label>
                        <input type="text" className="form-control" placeholder="Design" />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Role *</label>
                        <select className="form-select">
                          <option>Select Role</option>
                          <option>React JS Developer</option>
                        </select>
                      </div>
                    </div>
                  )}
                  {step === 3 && (
                    <div>
                      <h4>Job Type</h4>
                      <div className="mb-3">
                        <label className="form-label">Job Type *</label>
                        <input type="text" className="form-control" placeholder="Private, Government, etc." />
                      </div>
                    </div>
                  )}
                  {step === 4 && (
                    <div>
                      <h4>Preview</h4>
                      <p>Preview the details you've entered before submitting.</p>
                      {/* Here, you can display the form summary */}
                      <p><strong>Job Title:</strong> UI/UX Designer</p>
                      <p><strong>Number of Vacancies:</strong> 4</p>
                      {/* Add more details as necessary */}
                    </div>
                  )}
                  {step === 5 && (
                    <div>
                      <h4>Submit</h4>
                      <p>All details look good! You can now submit the job posting.</p>
                      <button className="btn btn-success">Submit</button>
                    </div>
                  )}
                </div>
              </div>

              {/* Navigation Buttons */}
              <div className="d-flex justify-content-between mt-4">
                <button
                  className="btn btn-secondary"
                  disabled={step === 1}
                  onClick={prevStep}
                >
                  Previous
                </button>
                <button
                  className="btn btn-primary"
                  disabled={step === 5}
                  onClick={nextStep}
                >
                  {step === 4 ? "Submit" : "Next"}
                </button>
              </div>
              </div>
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default JobPost